import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onDownloadSelected, onDeleteSelected, onMoveSelected, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-40">
      <div className="bg-card border border-border rounded-lg px-6 py-4 elevation-3 flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-accent/10 rounded-full flex items-center justify-center">
            <Icon name="Check" size={16} color="var(--color-accent)" />
          </div>
          <span className="text-sm font-medium text-foreground">
            {selectedCount} file{selectedCount > 1 ? 's' : ''} selected
          </span>
        </div>

        <div className="h-4 w-px bg-border" />

        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onDownloadSelected}
          >
            <Icon name="Download" size={16} />
            Download
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={onMoveSelected}
          >
            <Icon name="FolderOpen" size={16} />
            Move
          </Button>
          
          <Button
            variant="destructive"
            size="sm"
            onClick={onDeleteSelected}
          >
            <Icon name="Trash2" size={16} />
            Delete
          </Button>
        </div>

        <div className="h-4 w-px bg-border" />

        <Button
          variant="ghost"
          size="sm"
          onClick={onClearSelection}
        >
          <Icon name="X" size={16} />
          Clear
        </Button>
      </div>
    </div>
  );
};

export default BulkActionsBar;